import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'

import Loader from '../../shared/components/Loader'
import List from '../components/List'

@inject('museum')
@observer
export default class ListContainer extends Component {

  static propTypes = {
    museum: PropTypes.object,
  }

  componentWillMount() {
    const { museum } = this.props
    // if (!museum.length && !museum.collection.length) {
    museum.loadPublic()
    // }
  }

  render() {

    const { museum } = this.props

    return (
      <div className="vertical">
        <div
          className="vertical"
        >
          {museum.loading
            ? <Loader>Museumdaten werden geladen...</Loader>
            : <List store={museum} />}
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/museum/containers/List.js